import NewTabulator from "../../NewTabulator/NewTabulator";
import "./FactorJoz.scss";
import tableCalc from "../../../utils/tableCalc";
import { useState, useEffect, useRef } from "react";
import Select from "react-select";
import {
  calculateSumOfEachRow,
  myCustomCelEditFunction,
  deleteRowHandler,
} from "../Functions";
import parseToEnRemoveComma from "../../../utils/NumericFunction";
import { toast } from "react-toastify";
import _axios from "../../../httpService";

const FactorJoz = (props) => {
  const { sendData, setSendData, options, componentData, setComponentData } =
    props;
  const [selectedOption, setSelectedOption] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [reload, setReload] = useState(false);
  const [columnSum, setColumnSum] = useState(0);
  const tableRef = useRef();
  const columnsTable = [
    {
      title: "کد کالا",
      field: "productCode",
      style: {
        // width: 200,
        overflow: "hidden",
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
    },
    {
      title: "نام مواد اولیه",
      field: "nameMaterial",
      style: {
        overflow: "hidden",
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
    },
    {
      title: "تعداد",
      field: "number",
      editor: "number",
      style: {
        overflow: "hidden",
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
      formatter: tableCalc.separateNumbers,
      cellEdited: function (e, cell) {
        debugger;
        const value = parseToEnRemoveComma(e.target.value);
        // مقدار منحصر به فرد هر سطر داره بر اساس  کدمحصول گرفته میشه
        myCustomCelEditFunction(sendData, setSendData, cell, "number", value);
        setReload(!reload);
      },

      editorParams: {
        min: 1,
        step: 1,
      },
    },
    {
      title: "قیمت واحد",
      field: "price",
      style: {
        overflow: "hidden",
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
    },
    {
      title: "وضعیت مرجوعی",
      field: "returnStatus",
      style: {
        overflow: "hidden",
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
    },

    {
      title: "جمع کل",
      field: "totalSum",
      style: {
        // width: 200,
        overflow: "hidden",
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
      //   bottomCalc: tableCalc.sum,
    },
    {
      title: "عملیات",
      headerSort: false,
      formatter: "buttonCross", // width: 60,
      style: {
        // width: 50,
        overflow: "hidden",
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
      cellClick: function (e, cell) {
        console.log("حذف");
        const productCode = cell.getData().productCode;
        const tableData = deleteRowHandler(sendData.tableData, productCode);
        setSendData({ tableData });
      },
    },
  ];

  useEffect(() => {
    if (sendData.tableData.length > 0) {
      const sum = sendData.tableData.reduce(function (total, row) {
        return total + row.totalSum;
      }, 0);
      setColumnSum(sum.toString().replace(/^0+/, ""));
      setComponentData({ sumTotalInvoice: sum.toString().replace(/^0+/, "") });
    }
  }, [sendData.tableData]);


  const celEditHandler = (cell) => {
    setSendData({ tableData: calculateSumOfEachRow(sendData.tableData) });
  };

  useEffect(() => {
    setSendData({
      tableData: calculateSumOfEachRow(sendData.tableData),
    });
  }, [reload]);

  useEffect(() => {
    // in this section i Register cellEdited  To prevent So many Problems in Return I Off The Registered And Register Again When component Mount
    if (tableRef.current !== null && tableRef.current !== undefined) {
      if (
        tableRef.current.table !== null &&
        tableRef.current.table !== undefined
      ) {
        tableRef.current?.table?.on("cellEdited", celEditHandler);
        const css = "font-size: 22px;color:red;";
        console.log("%c" + "celEditHandler Registered", css);
        return () => {
          const css =
            "text-shadow: 1px 1px 2px black, 0 0 2px blue, 0 0 0.2em blue; font-size: 14px;";
          console.log("%c" + "Component unmounted or updated", css);
          tableRef.current?.table?.off("cellEdited", celEditHandler);
        };
      }
    }
  }, [sendData]);

  //for search input
  useEffect(() => {
    // Filter options based on search text
    const filtered = options.filter((option) =>
      option.label.toLowerCase().includes(searchText.toLowerCase())
    );
    setFilteredOptions(filtered);
  }, [searchText]);

  const handleChange = (selected) => {
    setSelectedOption(selected);
  };

  //fake url
  const url = "https://jsonplaceholder.typicode.com/posts";

  //function should be run when you clicked on a addBtnRow
  const addProductHandler = () => {
    debugger;
    if (selectedOption.value === "") {
      toast.error(`لطفا یک  کالا انتخاب کنید.`);
      return;
    }

    //sample data
    const data = {
      productCode: "1958",
      nameMaterial: "لباس",
      number: 1,
      price: "1230000",
      returnStatus: "بله",
    };

    _axios.get(url).then((res) => {
      console.log(res);
      if (res.status === 200) {
        addNewRowToPriceTable(data);
        setSelectedOption("");
      } else {
        toast.error(res.message);
      }
    });
  };

  //add new object to table
  const addNewRowToPriceTable = (inputObject) => {
    const objectData = { ...inputObject };
    //I know That productId is Uniq that backEnd Send to Front

    let tableData = [];
    let alreadyAdded = false;

    tableData =
      sendData?.tableData?.map((singleRow) => {
        if (+singleRow.productCode === +objectData.productCode) {
          singleRow.number = +singleRow.number + 1;
          alreadyAdded = true;
        }
        return singleRow;
      }) || [];

    if (!alreadyAdded) {
      tableData.push({ ...objectData });
    }
    tableData = calculateSumOfEachRow(tableData);
    setSendData({ tableData });
    // i will calculate sumPrice  of them in effect of show table Component
  };

  return (
    <div className="tables__wrapper">
      <div id="returnedGoodsFactor" className="Factor-table">
        <div className="searchboxPrnt__">
          <div className="searchBox__">
            <label>نام کالا</label>
            <Select
              id={"returnGoodName"}
              value={selectedOption}
              onChange={handleChange}
              options={filteredOptions}
              onInputChange={(inputValue) => setSearchText(inputValue)}
              isSearchable={true}
              placeholder="نام کالا را انتخاب کنید"
            />
          </div>
          <button className="addRowBtn_" onClick={addProductHandler}>
            <svg
              width="23"
              height="23"
              viewBox="0 0 23 23"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.3333 12.2188H7.66667C7.27376 12.2188 6.94792 11.8929 6.94792 11.5C6.94792 11.1071 7.27376 10.7812 7.66667 10.7812H15.3333C15.7263 10.7812 16.0521 11.1071 16.0521 11.5C16.0521 11.8929 15.7263 12.2188 15.3333 12.2188Z"
                fill="white"
              />
              <path
                d="M11.5 16.0521C11.1071 16.0521 10.7812 15.7263 10.7812 15.3334V7.66669C10.7812 7.27377 11.1071 6.94794 11.5 6.94794C11.8929 6.94794 12.2188 7.27377 12.2188 7.66669V15.3334C12.2188 15.7263 11.8929 16.0521 11.5 16.0521Z"
                fill="white"
              />
              <path
                d="M14.375 21.8021H8.625C3.42126 21.8021 1.19792 19.5788 1.19792 14.375V8.62502C1.19792 3.42127 3.42126 1.19794 8.625 1.19794H14.375C19.5788 1.19794 21.8021 3.42127 21.8021 8.62502V14.375C21.8021 19.5788 19.5788 21.8021 14.375 21.8021ZM8.625 2.63544C4.20709 2.63544 2.63542 4.2071 2.63542 8.62502V14.375C2.63542 18.7929 4.20709 20.3646 8.625 20.3646H14.375C18.7929 20.3646 20.3646 18.7929 20.3646 14.375V8.62502C20.3646 4.2071 18.7929 2.63544 14.375 2.63544H8.625Z"
                fill="white"
              />
            </svg>
          </button>
        </div>

        <div className="table_box_prnt">
          <div className="table_box">
            <NewTabulator
              ref={tableRef}
              columns={columnsTable}
              // data={dataEdit.main !== undefined ? dataEdit.particle.data : [] }
              data={sendData.tableData}
              // options={TabulatorTableOptions.style3}
              style={{ overflowY: "scroll" }}
              className={"header__color__F1F1F1 newTabulator_height"}
            />
            {sendData.tableData.map((v, index) => {
              return (
                <ul
                  className="responsive_table_records_parent"
                  key={"OCFG" + index}
                  id={v.productCode}
                >
                  <li>
                    <span className="res_table_title">کد کالا</span>
                    <span className="res_table_data" name="productCode">
                      {v.productCode}
                    </span>
                  </li>
                  <li>
                    <span className="res_table_title">نام مواد اولیه</span>
                    <span className="res_table_data" name="nameMaterial">
                      {v.nameMaterial}
                    </span>
                  </li>
                  <li>
                    <span className="res_table_title">تعداد</span>
                    <input
                      className="res_table_data"
                      name="number"
                      value={v.number}
                    />
                  </li>
                  <li>
                    <span className="res_table_title">قیمت واحد</span>
                    <span className="res_table_data" name="price">
                      {v.price}
                    </span>
                  </li>
                  <li>
                    <span className="res_table_title">وضعیت مرجوعی</span>
                    <span className="res_table_data" name="returnStatus">
                      {v.returnStatus}
                    </span>
                  </li>
                  <li>
                    <span className="res_table_title">جمع کل</span>
                    <span className="res_table_data" name="totalSum">
                      {v.totalSum}
                    </span>
                  </li>
                  <li>
                    <span className="res_table_title">عملیات</span>
                    <span
                      className="res_table_data"
                      onClick={deleteRowHandler(
                        sendData.tableData,
                        v.productCode
                      )}
                    >
                      <svg
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g opacity="0.99" clip-path="url(#clip0_567_6922)">
                          <path
                            d="M15.183 16.2435L6.6977 7.75823C6.40778 7.46831 6.40778 6.98748 6.6977 6.69757C6.98761 6.40765 7.46844 6.40765 7.75836 6.69757L16.2436 15.1828C16.5336 15.4728 16.5336 15.9536 16.2436 16.2435C15.9537 16.5334 15.4729 16.5334 15.183 16.2435Z"
                            fill="#F84459"
                          />
                          <path
                            d="M6.69752 16.2435C6.40761 15.9536 6.40761 15.4728 6.69752 15.1828L15.1828 6.69757C15.4727 6.40765 15.9536 6.40765 16.2435 6.69757C16.5334 6.98748 16.5334 7.46831 16.2435 7.75823L7.75818 16.2435C7.46827 16.5334 6.98744 16.5334 6.69752 16.2435Z"
                            fill="#F84459"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_567_6922">
                            <rect
                              width="15.5563"
                              height="15.5563"
                              fill="white"
                              transform="translate(11) rotate(45)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </span>
                  </li>
                </ul>
              );
            })}

            <div className="line__"></div>
          </div>
          <div className="totalSumOfTable__">
            <span className="totalText_">جمع کل فاکتور</span>
            <span className="totalPrice_">{componentData.sumTotalInvoice} ریال</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FactorJoz;
